var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: { type: "button" },
        on: { click: _vm.showAddForm }
      },
      [_vm._v("\n    Add a subgroup for this domain\n  ")]
    ),
    _vm._v(" "),
    _vm.showForm
      ? _c("div", { staticClass: "modal-backdrop fade in" })
      : _vm._e(),
    _vm._v(" "),
    _vm.showForm
      ? _c(
          "div",
          { staticClass: "modal fade in", staticStyle: { display: "block" } },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "dialog" } },
              [
                _c(
                  "div",
                  { staticClass: "modal-content" },
                  [
                    _c("SubgroupForm", {
                      on: { save: _vm.handleSave, cancel: _vm.closeForm }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }